import { Extension } from '@tiptap/core'

const TabExtension = Extension.create({
  name: 'custom-tab',

  addKeyboardShortcuts() {
    return {
      Tab: () => {
        const editor = this.editor

        if (!editor) {
          return false
        }

        editor.commands.insertContent('\t')
        return true // Prevent default tab behavior
      },
    }
  },
})

export default TabExtension
